import { render, staticRenderFns } from "./BarIc.vue?vue&type=template&id=b0409dd4"
import script from "./BarIc.vue?vue&type=script&lang=js"
export * from "./BarIc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports